export const GRADE_DATA_SUCCESS = "GRADE_DATA_SUCCESS";
export const GRADES_DATA_SUCCESS = "GRADES_DATA_SUCCESS";
export const UPDATE_GRADE_PROJECT_SUCCESS = "UPDATE_GRADE_PROJECT_SUCCESS";
export const CREATE_GRADE_PROJECT_SUCCESS = "CREATE_GRADE_PROJECT_SUCCESS";
export const GET_MATRIX_LIST = 'GET_MATRIX_LIST';




